<template>
    <div>
        <v-simple-table>
            <tr>
                <td v-if="diff.old !== null" width="45%">
                    <div class="d-flex flex-column" v-if="diff.new !== null">
                        <small>Ancien</small>
                        <span class="p-2">{{ diff.old }}</span>
                    </div>
                    <div class="d-flex flex-column" v-else>
                        <small style="color: #F44336">Supprimé</small>
                        <span class="p-2"
                              :style="'background-color:' + deleteColors.light + '; color:' + deleteColors.deep">
                            {{ diff.old }}
                        </span>
                    </div>
                </td>

                <td v-else width="45%"></td>

                <td v-if="diff.new !== null" width="45%">
                    <div class="d-flex flex-column">
                        <small :style="'color:' + getInputClass().deep">Nouveau</small>
                        <span :style="'background-color:' + getInputClass().light + '; color:' + getInputClass().deep"
                              class="p-2">
                        {{ diff.new }}
                    </span>
                    </div>
                </td>
                <td v-else width="45%"></td>
            </tr>
        </v-simple-table>
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "TextFieldDiffsVt",
    props: ["diff"],
    methods: {
        getInputClass() {
            if (this.diff.new !== null && this.diff.old === null) {
                return this.addColors
            } else if (this.diff.new !== null && this.diff.old !== null) {
                return this.updateColors
            } else if (this.diff.new === null && this.diff.old !== null) {
                return this.deleteColors
            }
        },
    },
    computed: {
        ...mapState("sitAnswer", [
            "addColors",
            "updateColors",
            "deleteColors",
        ]),
    },
}
</script>